module.exports = __webpack_public_path__ + "static/Calibre-Light-183de736efe789394f26ed013b0b5cdd.woff2";